import {styled} from '@mui/material/styles';

import { useEffect, useRef, useState } from 'react';

export function HiddenTransform({type='ver', children, open, width = '100%', time,...props}) {
    const ref = useRef({scrollWidth:0})
    useEffect(() => {
        ref.current.style.height = open ? ref.current.scrollHeight + 'px' : '0px'
    },[])
    useEffect(() => {
        if (open) {
            ref.current.style.height = ref.current.scrollHeight + 'px'
            const onEnd = () => {
                const opened = ref.current.style.height !== '0px'
                if (opened) {
                    ref.current.style.height = 'auto'
                }
                ref.current.removeEventListener('transitionend', onEnd);
            };
            ref.current.addEventListener('transitionend', onEnd);
        } else {
            ref.current.style.height = ref.current.scrollHeight + 'px'
            setTimeout(() => {
                ref.current.style.height = '0px'
            },0)
        }
    }, [open])

    return (
        <VerticalWrap
            time={time}
            ref={ref}
            {...props}
            // style={{
            //     height: 0,
            //     width: 0
            // }}
            // style={{
            //     height: (type === 'ver' || type === 'all') ? (initOpen ? ref.current.scrollHeight : 0) : 0,
            //     // width: (type === 'hor' || type === 'all') ? (initOpen ? ref.current.scrollWidth : 0) : width,
            // }}
        >
            {children}
        </VerticalWrap>
    )
}

const default_seconds = '.4s'
const VerticalWrap = styled('div')`
    position: relative;
    overflow: hidden;
    transition: ${p => {
        const s = p.time || default_seconds
        return `width ${s}, height ${s}, transform ${s}`
    }};
    -webkit-transition: ${p => {
        const s = p.time || default_seconds
        return `width ${s}, height ${s}, -webkit-transform ${s}`
    }};
`